<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OffersList from "@/router/views/promotions/offres";
import OrdersList from "@/components/orderslist";
import InvoicesList from "@/components/invoices-list"
import CatalogList from "@/components/catalog-list"
import NewsApi from "@/services/news-api";
import SupplierApi from "@/services/suppliers-api";

/**
 * Projects-list component
 */
export default {
  page: {
    title: "Catalogue du fournisseur",
    meta: [{ name: "description", content: appConfig.description }]
  },
  props: {
    supplierId: {
      type: Number,
    },
    isCashPaymentMandetory: {
      type: Number,
    },
  },
  components: { Layout,OffersList , OrdersList, InvoicesList,CatalogList },
  data() {
    return {
      title: "Liste des fournisseurs",
      daterange: "",
       articlesFields: [
        { key:"logo", label: "Logo",  thStyle:"width:70px;", thClass:"font-size-14", sortable: false, tdClass:"font-weight-bold"},
        { key:"name", label: "Nom du Fournisseur", thStyle:"width:350px;", thClass:"font-size-14",  tdClass:"font-size-18 align-middle", sortable: false},
        { key:"promotions", label: "Offres",  thStyle:"width:70px;", tdClass:"font-size-18 align-middle font-weight-bold", thClass:"font-size-16", sortable: false },
        { key:"catalog", label: "Catalogue",  thStyle:"width:50px;", sortable: false, thClass:"font-size-14", tdClass:"align-middle"},
      ],    
      
      supplier: {
        name:'',
        address:'',
        city: {name:''},
        country: {name:''}
      },
      
      pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
      
      isTableLoading: false,
      before:null,
      after:null,
      start:null,
      end:null,

      selectedState:null,
      orderStatus:null,
      status:[{name :"Nouvelle",value: 1},{name :"Confirmée", value: 2},{name :"Livrée", value: 3},{name :"Annulée", value: 4}],
      
      invoicesStatus:[{name :"Impayé",value: 0},{name :"Payé", value: 1}],
      selectedInvoiceState:null,
      invoiceStatus:null,

      newsList: [],
      pagemodelMainNews: {currentPage : 1, perPage : 6, totalRows: 0},
      isNewsListBusy:false,


    };
  },
  mounted(){
    this.loadSupplier(this.supplierId)
    //this.closeMenu();
    
  },
    methods: {
      loadSupplier(selectedSupplier) {
        if (selectedSupplier == null) {
          return;
        }
        SupplierApi.loadSupplier(selectedSupplier) 
        .then(supplier => {
            this.supplier = supplier;
          })
        },

        // closeMenu() {
        //     document.body.classList.add("vertical-collpsed");
        // },

        findNews() {
          this.isNewsListBusy = true;
          NewsApi.getNews(this.pagemodelMainNews.currentPage, this.pagemodelMainNews.perPage,this.supplierId).then((result) => {
            
            this.newsList = result.list;
            this.pagemodelMainNews.totalRows = result.total;
            this.pagemodelMainNews.currentPage = result.page;
            this.pagemodelMainNews.perPage = result.pageSize;
            this.pagemodelMainNews.pageSize = result.pageSize;
          }).finally(() => {
            this.isNewsListBusy = false;
          })
          ;
        },


  },
    watch: {
        end: function(){
          this.before = this.end? this.end : null
        },
        start: function(){
          this.after  = this.start? this.start : null
        },
        selectedState: function() {
            this.orderStatus = this.selectedState ? this.selectedState.value : null
        },

        selectedInvoiceState: function() {
            this.invoiceStatus = this.selectedInvoiceState ? this.selectedInvoiceState.value : null
        },
    }
};
</script>

<template>
  <Layout>
    

    <div class="row pt-4 pb-4">

      <div class="col-sm-4 pb-3 ">
        <div class="card h-100 border border-light" >
          <div class="card-body pb-0 pr-1">

          <div class="row pb-4">

            <div class="col-sm-8">
              <div class="row" style="min-height:35px;">
                <span class="font-weight-bold font-size-25 text-primary" style="font-size:25px;">{{supplier.name}}</span>
              </div>

              <div class="row pt-2">
                <span class="text-muted font-size-14" style="min-height:60px;">{{supplier.address}}, {{supplier.city.name}}, {{supplier.country.name}}</span>
              </div>

              <div class="row pt-2">
                <span class="text-muted font-size-14"><strong><i class="fas fa-phone-square  mr-2" />{{supplier.phone}}</strong></span> 
              </div>

              <div class="row">
                <span class="text-muted font-size-14"><strong><i class="far fa-envelope   mr-2" />{{supplier.mail}}</strong></span>
              </div>   

            </div>

            <div class="col-sm-1"/>

            <div class="col-sm-3">
              
              <img v-bind:src="'/api/image/get/'+supplier.logo" alt style=";width: 100%; ; margin: auto; display: block; ">
            </div>
            
          </div>

          <div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Site web" target="_blank" :href="supplier.webSite">
                  <i class="fas fa-globe text-primary"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Facebook" target="_blank" :href="supplier.facebook">
                  <i class="fab fa-facebook-square text-primary"></i>
                </a>
              </div>

              <div class="flex-fill text-center">
                <a v-b-tooltip.hover.top title="Instagram" target="_blank" :href="supplier.instagram">
                  <i class="fab fa-instagram text-primary"></i>
                </a>
              </div>
                
            </div>
          </div>



        </div>
      </div>
      </div>

      <div class="col-sm-4 pl-sm-3 pb-3">

        <div class="card h-100  border border-light" >
          <div class="card-body pb-0 pr-1">

            <h4 class="card-title pt-3"><i class="far fa-money-bill-alt mr-2" />Conditions Générales d'Achats :</h4>
            
            <div >
            <ul class="pt-3">
              <li class="pb-2 font-size-13">Remise sur facture : <strong class="font-size-14 text-primary"> {{supplier.invoiceDiscount}}%</strong></li>
              <li class="pb-2 font-size-13">Délai de Paiement : <strong class="font-size-14 text-primary">{{supplier.paymentDays}} jours</strong></li>
              <li class="pb-2 font-size-13">Remise pour paiement comptant : <strong class="font-size-14 text-primary"> {{supplier.cashPaymentDiscount}}%</strong></li>
              <li class="pb-2 font-size-13">Minimum de Commande : <strong class="font-size-14 text-primary">{{supplier.minOrderValue}} TND</strong> </li>
              <li class="pb-2 font-size-13">Minimum de Références : <strong class="font-size-14 text-primary">{{supplier.minOrderItemsCount}}</strong></li>
              <li class="pb-2 font-size-13">Délai de Livraison : <strong class="font-size-14 text-primary">{{supplier.deliveryDays}} jours</strong></li>
              <li class="pb-2 font-size-13">Reprise des périmés : <strong class="font-size-14 text-primary"> 
                {{(supplier.expiredItemReturn ? 'Oui' : 'Non')+ (supplier.expiredItemReturnString ? ', '+ supplier.expiredItemReturnString : '')}}
                </strong>
              </li>

            </ul>
            </div>

          </div>
        </div>

      </div>

      
      <div class="col-sm-4 pl-sm-3 pb-3">

        <div class="card h-100  border border-light" >
          <div class="card-body pb-0 pr-1">

            <h4 class="card-title"><i class="mdi mdi-bank mr-2" />Relevé d'Identité Bancaire (RIB) :</h4>
            <span v-if="supplier.bank && supplier.rib" class="text-muted font-size-14">{{supplier.bank}} - {{supplier.rib}}</span>


            <h4 class="card-title pt-3"><i class="far fa-user mr-2" />Représentants :</h4>
              <div class="table-responsive mb-0" style="max-height:170px; overflow-y:auto;">

                    <ul v-for="contact in supplier.contacts" :key="contact.id" >
                        <li class="pb-1 font-size-14"><strong class="text-primary">{{contact.firstName}} {{contact.lastName}}</strong><br>
                            <span>{{contact.position}}</span><br>
                            <i class="fas fa-phone-square mr-2" />{{contact.phone}} <i class="far fa-envelope ml-3  mr-2"/>{{contact.email}} 
                        </li>
                    </ul>

              </div>


          </div>
        </div>

      </div>


    </div>


    <div class="row  pt-0">
      <div class="col-lg-12" >

        <b-tabs content-class="p-0 pb-4" >
          <b-tab class="border border-2" lazy @click="findNews" >
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home font-size-16"></i>
              </span>
              <span class="d-none d-sm-inline-block font-size-16"><i class="d-none d-sm-inline-block fas fa-home font-size-16"/></span>
            </template>
                <div class="card mr-2 pt-4" style="height:45em; border-left:1px solid #cdd3d9; border-right:1px solid #cdd3d9; border-bottom:1px solid #cdd3d9;">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6 float-left">
                        <h4 class="card-title text-primary" style="font-size: 25px">
                      Actualités et Faits marquants
                    </h4>
                      </div>
                      <div class="col-6 float-right">
                      </div>
                    </div>
                    
                    
                    <p class="card-title-desc pb-3">
                      Actualités, évènements et faits marquants du fournisseur.
                    </p>

                    <ul class="verti-timeline list-unstyled" >
                      <li v-for="data in newsList" :key="data.id" class="event-list">
                        <div class="event-timeline-dot">
                          <i class="bx bx-right-arrow-circle font-size-18"></i>
                        </div>
                        <div class="media">
                          <div class="mr-3">
                            <h5 class="font-size-12">
                              {{ data.formatedDate }}
                              <i
                                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                              ></i>
                            </h5>
                          </div>
                          <div class="media-body">
                            {{ data.text }}
                          </div>
                        </div>
                      </li>
                      <div v-if="isNewsListBusy" class="d-flex justify-content-center">
                                <div class="spinner-border text-success" role="status">
                                    <span class=" sr-only">Chargement...</span>
                                </div>
                        </div>
                        <span v-if="!isNewsListBusy && !newsList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune Actualité dans la liste</span>
                    </ul>
                  </div>
                  <div class="card-footer bg-transparent">
                    <div class="text-center mt-4">
                      <!-- Pagination -->
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="pagemodelMainNews.currentPage" :disabled="isNewsListBusy" :per-page="pagemodelMainNews.pageSize" :total-rows="pagemodelMainNews.totalRows" @input="findNews()" ></b-pagination>
                            </ul>
                          </div>
                      <!-- Fin Pagination  -->
                    </div>
                  </div>
                </div>
                 <!-- <div class="card pt-4">
                  <div class="card-body">
                    <h4 class="card-title">Actualités du Laboratoire</h4>
                      <p class="card-title-desc">
                        Actualités, évènements et faits marquants.
                      </p>
                      <ul class="verti-timeline list-unstyled" style="filter: blur(4px)">
                        
                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                20/10/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                05/10/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                <div class="media-body">
                              <div>Vestibulum viverra, dolor at ornare congue, risus massa ullamcorper elit</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                18/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Nullam porta eget diam id pretium</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                16/19/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Curabitur pellentesque, arcu ut vulputate porttitor, tellus risus auctor felis</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                14/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Interdum et malesuada fames ac ante ipsum primis in faucibus.</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                10/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Ut non est eu dui ornare posuere sit amet mollis nisi.</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                10/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Vestibulum ut posuere ante, sed lobortis diam.</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                10/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Offre spéciale automne et hiver 2020 (sur tous les produits SVR)</div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                10/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Vestibulum efficitur lorem at quam lobortis auctor. </div>
                            </div>
                          </div>
                        </li>

                        <li class="event-list">
                          <div class="event-timeline-dot">
                            <i class="bx bx-right-arrow-circle font-size-18"></i>
                          </div>
                          <div class="media">
                            <div class="mr-3">
                              <h5 class="font-size-14">
                                10/09/2020
                                <i
                                  class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ml-2"
                                ></i>
                              </h5>
                            </div>
                            <div class="media-body">
                              <div>Sed id libero scelerisque, bibendum ante eget, hendrerit odio.</div>
                            </div>
                          </div>
                        </li>
                        
                      </ul>
                        
                    <div class="text-center mt-4">
                      <a href="javascript: void(0);" class="btn btn-primary btn-sm">Afficher plus</a>
                    </div>
                  </div>
                </div> -->
            </b-tab>


              <b-tab active lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-list-alt font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block far fa-list-alt font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Catalogue</span>
                </template>
                <div class="card pt-4 " style="border-left:1px solid #cdd3d9; border-right:1px solid #cdd3d9; border-bottom:1px solid #cdd3d9;">
                  <div class="card-body">
                    <h4 class="card-title">Catalogue du fournisseur</h4>
                      <p class="card-title-desc">
                        Liste des articles du fournisseur
                      </p>
                  </div>
                  <CatalogList :selectedSupplier=this.supplierId :isCashPaymentMandatory=this.isCashPaymentMandetory />
                </div>
              </b-tab>

              <b-tab lazy>
                <template v-slot:title >
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-hand-holding-usd font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block fas fa-hand-holding-usd font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Offres en cours</span>
                </template>
                  <div class="card pt-4" style="border-left:1px solid #cdd3d9; border-right:1px solid #cdd3d9; border-bottom:1px solid #cdd3d9;">
                  <div class="card-body">
                    <h4 class="card-title">Les Offres en cours</h4>
                      <p class="card-title-desc">
                        Promotions et Offres du fournisseur
                      </p>

                <div class="row mt-2">
                  <div class="col-sm-5 col-xs-6"/>
                  <div class="col-sm-1 col-xs-0"/>

                  <!-- <div class="col-sm-3 col-xs-12 pr-sm-2">
                    <b-form-group label="Date Début" label-for="">
                      <b-form-datepicker
                        v-model="start"
                        locale="fr"
                        label-no-date-selected="Date Début"
                        dark
                        reset-button
                        close-button
                        dropright
                        hide-header
                      ></b-form-datepicker>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3 col-xs-12">
                    <b-form-group label="Date Fin" label-for="">
                      <b-form-datepicker
                        v-model="end"
                        locale="fr"
                        label-no-date-selected="Date Fin"
                        dark
                        reset-button
                        close-button
                        dropright                         
                        hide-header
                      ></b-form-datepicker>
                    </b-form-group>
                  </div> -->
                </div>
                    <OffersList :selectedSupplier=this.supplierId :before.sync=this.before :after.sync=this.after /> 

                  </div>
                </div>
              </b-tab>

              <b-tab lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cart-plus font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block fas fa-cart-plus font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Commandes</span>
                </template>
                <div class="card pt-4" style="border-left:1px solid #cdd3d9; border-right:1px solid #cdd3d9; border-bottom:1px solid #cdd3d9;">
                  <div class="card-body">
                    <h4 class="card-title">Mes commandes</h4>
                      <p class="card-title-desc">
                        Liste des commandes
                      </p>
                <div  class="row mt-2">
                  <div  class="col-sm-5 col-xs-6"/>
                  <div class="col-sm-4 col-xs-0"/>
                  <div class="col-sm-3 col-xs-0">
                    <b-form-group label="Etat" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="status" placeholder="Etat" label="name" v-model="selectedState" :searchable="false">
                        <span slot="no-options">Aucun etat dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </div>
                      <OrdersList :isAllOrders="false" :supplierId=this.supplierId :status.sync=this.orderStatus />
                  </div>
                </div>
              </b-tab>

              <b-tab lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-file-alt  font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block far fa-file-alt  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Factures</span>
                </template>
                <div class="card pt-4" style="border-left:1px solid #cdd3d9; border-right:1px solid #cdd3d9; border-bottom:1px solid #cdd3d9;">
                  <div class="card-body">
                    <h4 class="card-title">Mes factures</h4>
                      <p class="card-title-desc">
                        Liste des factures
                      </p>
                      <div class="row mt-2">
     
                        <div  class="col-sm-5 col-xs-6"/>
                        <div class="col-sm-4 col-xs-0"/>
                        <div class="col-sm-3 col-xs-0">
                          <b-form-group label="Etat" label-for="">
                            <v-select class="style-vselect" style="font-size:16px;" :options="invoicesStatus" placeholder="Etat" label="name" v-model="selectedInvoiceState" :searchable="false">
                              <span slot="no-options">Aucun etat dans la liste</span>
                            </v-select>
                          </b-form-group>
                        </div>
                      </div>
                      <InvoicesList :selectedSupplier=this.supplierId :status.sync=this.invoiceStatus   />
                  </div>
                </div>
              </b-tab>
              
            </b-tabs>

          <!-- </div> -->
        </div>
      <!-- </div> -->
    </div>
    
  </Layout>
</template>